import { Box } from 'components/ui';
import type { AuthSignInRedirectTextProps } from './AuthSignInRedirectText.props';

const AuthSignInRedirectText = ({ countdown }: AuthSignInRedirectTextProps) => (
  <>
    You will be redirected to the sign in page in{' '}
    <Box component="span" sx={{ fontWeight: 700 }}>
      {countdown}
    </Box>{' '}
    {countdown === 1 ? 'second.' : 'seconds.'}
  </>
);

export default AuthSignInRedirectText;
